<template>
  <CustomPage title="店主发红包" style="background: #f7f7f7" backRoute="Store">
    <div slot="content" style="height: 100%">
      <div class="redpack-container">
        <div
          class="
            flex flex-wrap
            justify-evenly
            text-center text-sm
            bg-white
            items-center
          "
          style="height: 55px"
        >
          <div class="box-border w-3/12 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status == 0 }"
              style="width: 12rem"
              @click="status = 0"
            >
              即将开始
            </div>
          </div>

          <div class="box-border w-3/12 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status == 1 }"
              style="width: 12rem"
              @click="status = 1"
            >
              待发放
            </div>
          </div>
          <div class="box-border w-3/12 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status == 2 }"
              style="width: 12rem"
              @click="status = 2"
            >
              已失效
            </div>
          </div>
        </div>
        <div
          class="m-3 overflow-y-auto pb-12"
          style="max-height: calc(100vh - 120px)"
        >
          <div
            v-for="item in redpackList"
            :key="item.id"
            class="
              rounded-lg
              overflow-hidden
              lightshadow
              flex flex-row
              text-white
              bg-white
              mb-3
              items-center
              justify-between
              h-32
            "
          >
            <div
              class="
                w-32
                flex flex-col
                justify-center
                items-center
                p-3
                flex-grow-0
                h-full
              "
              :style="{
                background:
                  status != 2
                    ? 'linear-gradient(90deg, #FB8787 0%, #E75050 100%)'
                    : '#CECECE',
              }"
            >
              <div>
                <span class="text-xl">¥&nbsp;</span
                ><span
                  class="leading-10 font-semibold"
                  style="letter-spacing: 0.1rem; font-size: 2.5rem"
                  >{{ item.reduceAmount }}</span
                >
              </div>
              <div class="text-xs font-light">满{{ item.fullAmount }}可用</div>
            </div>
            <div class="flex-grow">
              <div class="flex justify-between flex-grow">
                <div class="text-left ml-3 items-end">
                  <div class="text-black text-sm">{{ item.title }}</div>
                  <div class="text-xxs">
                    <span class="text-red mr-1">店主赠送</span
                    ><span class="text-black">{{
                      {
                        ALL_FANS: "全部粉丝可领",
                        NEW_FANS: "新粉丝可领",
                        COMMAND: "口令红包",
                        ASSIGN: "指定好友红包",
                      }[item.storeRedPacketType]
                    }}</span>
                  </div>
                  <div class="text-xs text-gray mt-1">
                    {{ item.startDate }} - {{ item.endDate }}
                  </div>
                </div>

                <img
                  v-if="status == 2"
                  :src="require('@/assets/redpack/yiguoqi.svg')"
                />
              </div>
              <div class="flex justify-between ml-3 items-end">
                <div class="text-red text-xxs">
                  已领取{{ item.redPacketNum }}/{{
                    item.redPacketNum - item.remainNum
                  }}
                </div>
                <Button
                  v-if="item.storeRedPacketType === 'COMMAND' && item.remainNum"
                  class="w-16 self-end"
                  style="
                    padding-left: 6px;
                    padding-right: 6px;
                    margin-right: 0.75rem;
                  "
                  type="danger"
                  round
                  plain
                  color="red"
                  size="mini"
                  @click="
                    () => {
                      editingCommand = item.command;
                      showCommand = true;
                    }
                  "
                  >查看口令</Button
                ><Button
                  v-else-if="
                    item.storeRedPacketType === 'ASSIGN' && item.remainNum
                  "
                  class="w-16 self-end"
                  style="
                    padding-left: 6px;
                    padding-right: 6px;
                    margin-right: 0.75rem;
                  "
                  type="danger"
                  round
                  plain
                  color="red"
                  size="mini"
                  @click="
                    () => {
                      editingStoreRedPacketId = item.redPacketId;
                      showFriendId = true;
                    }
                  "
                  >输入好友ID</Button
                >
              </div>
            </div>
          </div>
        </div>
        <Popup
          v-model="showFriendId"
          class="text-center rounded lightshadow p-2"
        >
          <div>请输入你的好友手机号</div>
          <Field v-model="goodFriendId" class="bg-f8" />
          <Button
            style="
              background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
              height: 40px;
            "
            size="large"
            @click="giveFriend"
            ><span class="text-white">确定</span></Button
          >
        </Popup>
        <Popup
          v-model="showCommand"
          class="text-center rounded lightshadow p-2"
        >
          <div>您的红包口令为</div>
          <Field v-model="editingCommand" readonly />
          <Button
            style="
              background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
              height: 40px;
            "
            size="large"
            @click="copyC"
            ><span class="text-white">复制</span></Button
          >
        </Popup>
        <Empty
          v-show="!redpackList.length"
          :image="require('@/assets/redpack/meiyouhongbao.svg')"
          description="暂无红包"
        />
        <Button
          round
          style="
            position: fixed;
            background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
            width: 80%;
            margin: 0 10%;
            bottom: 20px;
            height: 40px;
          "
          size="large"
          @click="$router.push({ name: 'SendStoreRedpack' })"
          ><span class="text-white">塞钱发红包</span></Button
        >
      </div>
      <!-- <BoughtDialog/> -->
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
// import BoughtDialog from "@/components/BoughtDialog.vue";
import { Button, Empty, Popup, Field, Toast } from "vant";
import { getStoreRedpackList, assignStoreRedpack } from "./webApi";
export default {
  components: { CustomPage, Button, Empty, Popup, Field },
  created() {
    this.getStoreRedpackList();
  },

  data() {
    return {
      status: 0,
      redpackList: [],
      showFriendId: false,
      showCommand: false,
      goodFriendId: null,
      editingStoreRedPacketId: null,
      editingCommand: null,
    };
  },
  methods: {
    getStoreRedpackList() {
      getStoreRedpackList({
        classify: [null, "assign", "invalid"][this.status],
      }).then(({ data }) => {
        this.redpackList = data;
      });
    },
    giveFriend() {
      assignStoreRedpack({
        redPacketId: this.editingStoreRedPacketId,
        mobile: this.goodFriendId,
      }).then((res) => {
        Toast({
          message: res.message,
          position: "center",
          duration: 1000,
        });
        this.showFriendId = false;

        this.getStoreRedpackList();
      });
    },
    copyC() {
      try {
        const input = document.createElement("input");
        input.value = this.editingCommand;
        document.body.appendChild(input);
        input.setAttribute("readonly", "readonly");
        input.select();
        input.setSelectionRange(0, input.value.length),
          document.execCommand("Copy");
        document.body.removeChild(input)
        Toast.success("已复制到剪切板");
        this.showCommand = false;
      } catch (error) {
        Toast.fail("复制失败");
      }
    },
  },
  watch: {
    status() {
      this.getStoreRedpackList();
    },
  },
};
</script>

<style scoped>
.active {
  background-color: #d8283b !important;
  color: #fff;
}
</style>
